import { useMutation } from "./helper";
import { submitRegistration } from "../../../api/registration";
import { submitSurvey } from "../../../api/registration";

export const useRegisterDevice = () => useMutation({
    mutationFn: submitRegistration,
});

export const useSubmitSurvey = () => useMutation({
    mutationFn: submitSurvey,
});